export { SetUpService } from './set-up-service.component';
